module.exports = __webpack_public_path__ + "img/jsfn.b591345c.png";